import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./IssuesWeFix.css";

function IssuesWeFix() {
  const issues = [
    {
      slug: "cracked-screen",
      title: "Cracked Screen",
    },
    {
      slug: "touchscreen-not-working",
      title: "Touchscreen Not Working",
    },
    {
      slug: "battery-draining-fast",
      title: "Battery Draining Fast",
    },
    {
      slug: "phone-not-charging",
      title: "Phone Not Charging",
    },
    {
      slug: "charging-port-issues",
      title: "Charging Port Issues",
    },
    {
      slug: "face-id-problems",
      title: "Face ID Problems",
    },
    {
      slug: "camera-not-working",
      title: "Camera Not Working",
    },
    {
      slug: "speaker-issues",
      title: "Speaker Issues",
    },
    {
      slug: "microphone-problems",
      title: "Microphone Problems",
    },
    {
      slug: "water-damage",
      title: "Water Damage",
    },
    {
      slug: "software-bugs",
      title: "Software Bugs",
    },
    {
      slug: "phone-overheating",
      title: "Phone Overheating",
    },
    {
      slug: "network-problems",
      title: "Network Problems",
    },
    {
      slug: "data-recovery",
      title: "Data Recovery",
    },
    {
      slug: "boot-loop-issues",
      title: "Boot Loop Issues",
    },
    {
      slug: "motherboard-faults",
      title: "Motherboard Faults",
    },
  ];

  return (
    <section className="issues-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Common Problems</span>

          <h2 className="section-title">Issues We Fix Every Day</h2>

          <p className="section-description">
            Our technicians are experienced in diagnosing and repairing all
            types of hardware and software issues.
          </p>
        </div>

        <div className="issues-list">
          {issues.map((issue, index) => (
            <Link
              to={`/issues/${issue.slug}`}
              className="issue-item"
              key={issue.slug}
              data-aos="zoom-in"
              data-aos-delay={(index % 4) * 100}
            >
              <FaCheckCircle className="issue-icon" />

              <span>{issue.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IssuesWeFix;